export const locations = [
  { id: 0, zip: "", name: "Milano" },
  { id: 1, zip: "20121", name: "Brera, Milano" },
  { id: 2, zip: "20123", name: "Carrobbio, Milano" },
  { id: 3, zip: "20121", name: "Castello - Foro Bonaparte, Milano" },
  { id: 4, zip: "20154, 20155", name: "Cenisio - Firenze - Portello, Milano" },
  { id: 5, zip: "20124, 20131", name: "Centrale - Loreto, Milano" },
  { id: 6, zip: "20129", name: "Città Studi, Milano" },
  { id: 7, zip: "20121", name: "Cordusio, Milano" },
  { id: 8, zip: "20122", name: "Duomo, Milano" },
  { id: 9, zip: "20145", name: "Fiera - Citylife, Milano" },
  { id: 10, zip: "20146", name: "Gambara - Bande Nere, Milano" },
  { id: 11, zip: "20121", name: "Garibaldi - Moscova - Arena, Milano" },
  {
    id: 12,
    zip: "20129",
    name: "Indipendenza - V Giornate - XXII Marzo, Milano",
  },
  {
    id: 13,
    zip: "20124, 20125, 20159",
    name: "Isola - Gioia - Maggiolina, Milano",
  },
  { id: 14, zip: "20123, 20145", name: "Magenta - Monti - Pagano, Milano" },
  { id: 15, zip: "20135", name: "Medaglie D'Oro - Lodi, Milano" },
  { id: 16, zip: "20122", name: "Missori - Corso Italia, Milano" },
  { id: 17, zip: "20149", name: "Monte Rosa - Ravizza - Amendola, Milano" },
  { id: 18, zip: "20129", name: "Morgagni - Bacone, Milano" },
  {
    id: 19,
    zip: "20136, 20143, 20144",
    name: "Porta Genova - Navigli, Milano",
  },
  { id: 20, zip: "20121", name: "Porta Nuova - XXV Aprile, Milano" },
  { id: 21, zip: "20122", name: "Porta Romana - Crocetta - Quadronno, Milano" },
  { id: 22, zip: "20136", name: "Porta Ticinese-Bocconi, Milano" },
  { id: 23, zip: "20121", name: "Porta Venezia, Milano" },
  { id: 24, zip: "20121", name: "Palestro, Milano" },
  { id: 25, zip: "20121", name: "Quadrilatero, Milano" },
  { id: 26, zip: "20123", name: "Repubblica - Turati, Milano" },
  { id: 27, zip: "20123", name: "San Babila, Milano" },
  { id: 28, zip: "20129", name: "San Siro, Milano" },
  { id: 29, zip: "20148", name: "Sant'Ambrogio, Milano" },
  { id: 30, zip: "20129", name: "Sempione - Arco della Pace, Milano" },
  { id: 31, zip: "20136", name: "Solari - Tortona, Milano" },
  {
    id: 32,
    zip: "20145, 20154",
    name: "Vercelli - Washington - Wagner, Milano",
  },
  {
    id: 33,
    zip: "",
    name: "Milano",
  },
];

export const sortByOptions = [
  { label: "Più costosi", value: "most_expensive" },
  { label: "Più grandi", value: "largest" },
  { label: "Più locali", value: "most_rooms" },
  { label: "Più recenti", value: "most_recent" },
  { label: "Meno costosi", value: "least_expensive" },
  { label: "Meno grandi", value: "smallest" },
  { label: "Meno locali", value: "least_rooms" },
  { label: "Meno recenti", value: "least_recent" },
];

export const PLAN_FEATURES = {
  free: [
    "Comparazione su Tutte le Piattaforme",
    "Organizer con Cartelle Condivise",
    "Location Intelligence",
    "Alert Nuovi Annunci",
    "Calcolatore Costi Nascosti",
    "Estensione Chrome HouseScan",
  ],
  premium: [
    "Comparazione su Tutte le Piattaforme",
    "Organizer con Cartelle Condivise",
    "Location Intelligence",
    "Alert Nuovi Annunci",
    "Calcolatore Costi Nascosti",
    "Estensione Chrome HouseScan",
    "Storicità Annunci",
    "ROI Analysis",
    "Variazione dei Prezzi",
    "Dashboard Avanzata",
  ],
};
